import * as types from '@phoenix/store/mutations-types';
import { clientApi } from '@phoenix/clientApi';

const initialState = {
  pastEvents: [],
  futureEvents: [],
  isLoading: false,
  hasResults: false,
  request: null,
  hasBeenLoaded: false,
};

const getters = {
  hasFutureEvents: (state) => state.futureEvents?.length > 0,
  futureEvents: (state) => state.futureEvents,
  pastEvents: (state) => state.pastEvents,
  isLoading: (state) => state.isLoading,
  hasResults: (state) => state.hasResults,
};

const actions = {
  async fetchData({ commit, state }, pageId) {
    if (state.hasResults) {
      return;
    }
    commit(types.EVENTS_MENU_SET_LOADING, true);

    if (state.request) {
      state.request.cancel();
    }
    commit(types.EVENTS_MENU_SET_REQUEST, clientApi.getCancelToken().source());

    try {
      const {
        data: { data },
      } = await clientApi.get(window.route('api.search.latest.events'), {
        params: { pageId },
        cancelToken: state.request.token,
      });

      commit(types.EVENTS_MENU_SET_REQUEST, null);
      commit(types.EVENTS_MENU_SET_RESULTS, data);
    } catch (error) {}

    commit(types.EVENTS_MENU_SET_LOADING, false);
  },
};

const mutations = {
  [types.EVENTS_MENU_SET_RESULTS](state, { pastEvents, futureEvents }) {
    state.futureEvents = futureEvents;
    state.pastEvents = pastEvents;
    state.hasResults = true;
  },

  [types.EVENTS_MENU_SET_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },

  [types.EVENTS_MENU_SET_REQUEST](state, request) {
    state.request = request;
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions,
  mutations,
};
